import { VuexResponse } from '@helpers/vuex-action-builder'
import FormDTO from '@/models/form/formDTO'
import GetFormDTO from '@/models/form/getFormDTO'

const getDefaultState = () => {
  return {
    forms: [],
    requiringActionForms: [],
    form: null,
    loading: 0,
  }
}

const state = getDefaultState()

export default {
  namespaced: true,
  state,
  getters: {
    moduleName: () => 'forms',
    forms: (state) => state.forms,
    requiringActionForms: (state) => state.requiringActionForms,
    form: (state) => state.form,
    isLoading: (state) => state.loading > 0,
  },
  mutations: {
    INCREMENT_LOADING(state) {
      state.loading++
    },
    DECREMENT_LOADING(state) {
      state.loading--
    },
    SET_FORMS(state, forms) {
      state.forms = forms
    },
    SET_REQUIRING_ACTION_FORMS(state, requiringActionForms) {
      state.requiringActionForms = requiringActionForms
    },
    SET_FORM(state, form) {
      state.form = form
    },
  },
  actions: {
    async getForms({ commit, dispatch }) {
      return await new VuexResponse(commit, dispatch)
        .request(() => this.$api.forms.getForms())
        .transform((data) => data.forms.map((item) => new FormDTO(item)))
        .withCommit('SET_FORMS')
        .withLoading('INCREMENT_LOADING', 'DECREMENT_LOADING')
        .go()
    },
    async getFormsStatus({ commit, dispatch }) {
      return await new VuexResponse(commit, dispatch)
        .request(() => this.$api.forms.getFormsStatus())
        .transform((data) => data.forms.map((item) => new FormDTO(item)))
        .withCommit('SET_REQUIRING_ACTION_FORMS')
        .go()
    },

    async getForm({ commit, dispatch }, { id, type }) {
      return await new VuexResponse(commit, dispatch)
        .request(() => this.$api.forms.getForm(type, id))
        .transform((data) => new GetFormDTO(data))
        .withCommit('SET_FORM')
        .go()
    },
  },
}
